import type { SettingValueMap } from 'portlet/models';

import type { QueryReplacer } from '.';

export const ConditionOrderReplacer: QueryReplacer = {
    regex: /\{conditionOrder\}/,
    replace: (statement, _metadata, _filterValues, regexMatches, settings) => {
        const value = getDatabricksConditionOrderValue(settings);

        return regexMatches.reduce((pre, cur) => pre.replace(cur.exact, value), statement);
    },
};

export function getDatabricksConditionOrderValue(settings: Partial<SettingValueMap>): string {
    return settings.DATABRICKS_CONDITION && settings.DATABRICKS_CONDITION.order
        ? settings.DATABRICKS_CONDITION.order
        : '';
}
